import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import {
  AtlassianNavigation,
  PrimaryButton,
  Create as CreateButton,
} from '@atlaskit/atlassian-navigation';

import { LinkWithRef } from '@/components/primitive';
import FeedbackLink from '@/components/primitive/feeback-link';
import { useLocationController, useFeatureGatesController } from '@/controllers';
import { flex, flexCenter, spaceGapCompact, spaceGapCozy } from '@/styles';

import * as styles from './styles';
import NavSettings from './nav-settings';
import NavLogo from './nav-logo';
import NavProfile from './nav-profile';
import NavHelp from './nav-help';
import NavSearch from './nav-search';
import { btnWithLozenge } from './styles';

type NavProps = {
  onCreate: () => void;
};

const Nav: React.FC<NavProps> = ({ onCreate }) => {
  const { isSearchPage, isHomepage, isSimulateAlertPage } = useLocationController();
  const { allowSimulation } = useFeatureGatesController();

  return (
    <div css={[styles.root, styles.nav]}>
      <AtlassianNavigation
        label="Tome"
        renderSettings={NavSettings}
        renderProductHome={NavLogo}
        renderCreate={() => (
          <span css={{ display: 'flex', gap: '0.5rem' }}>
            <CreateButton text="Create" onClick={onCreate} />
          </span>
        )}
        renderHelp={NavHelp}
        renderSearch={() => (
          <span css={[flex, spaceGapCozy]}>
            <FeedbackLink />
            <NavSearch />
          </span>
        )}
        primaryItems={[
          <PrimaryButton key="home" href="/" isHighlighted={isHomepage} component={LinkWithRef}>
            Home
          </PrimaryButton>,
          <PrimaryButton
            key="search"
            href="/search"
            isHighlighted={isSearchPage}
            component={LinkWithRef}
          >
            Search
          </PrimaryButton>,
          allowSimulation ? (
            <PrimaryButton
              key="simulate-alert"
              href="/simulate"
              isHighlighted={isSimulateAlertPage}
              component={LinkWithRef}
            >
              <div css={[spaceGapCompact, flexCenter]}>
                <span>Simulate Alert</span>
                <span css={btnWithLozenge}>
                  <Lozenge appearance="new">experimental</Lozenge>
                </span>
              </div>
            </PrimaryButton>
          ) : null,
        ]}
        renderProfile={NavProfile}
      />
    </div>
  );
};

export default Nav;
